import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from '../Avatar';
import EmptystateButton from './EmptystateButton';

const NewMessages = ({ onClickChat, onClickChats, chats, total, remaining }) => {
  const { t } = useTranslation('components');

  const isAudioMessage = ({ files }) =>
    files.length > 0 && ['audio', 'video'].some(type => files[0].mediaType.includes(type));

  return (
    <div data-component="PhysicianWelcomeScreen__UnreadChats" className="mb-8">
      <h2 className="font-semibold text-xl text-slate-500 mb-2">
        {t('physician_welcome_screen.unread.title')}
      </h2>
      <div className="min-w-0">
        {chats.map(({ id, text, title, avatar, initials, isDeleted, files, subtitle }) => (
          <button
            key={`unreadChat#${id}`}
            type="button"
            onClick={event => {
              event.preventDefault();
              onClickChat({ id }, event);
            }}
            className="w-full flex bg-white border-t border-l border-r last:border-b p-4 items-center cursor-pointer hover:bg-slate-50 group min-w-0 text-left"
          >
            <Avatar src={avatar} initials={initials} alt={title} className="mr-3 flex-none" />
            <div className="truncate min-w-0 lg:max-w-2xl">
              <span className="block font-semibold leading-tight group-hover:text-blue-500 truncate">
                {title}
              </span>
              {subtitle && (
                <span className="block leading-tight truncate text-slate-600 text-sm">
                  {subtitle}
                </span>
              )}
              <span className="block text-sm text-slate-500 mt-1 truncate">
                {!isDeleted ? (
                  text
                ) : (
                  <span className="italic">{t('physician_welcome_screen.unread.deleted')}</span>
                )}
              </span>
              {!isDeleted && files && (
                <span className="block leading-tight text-sm text-slate-500 italic truncate">
                  {isAudioMessage({ files }) ? (
                    t('physician_welcome_screen.unread.voiceMessage')
                  ) : (
                    <>
                      {t('physician_welcome_screen.unread.file_message', { count: files.length })}{' '}
                      {files.map(({ mediaType: name }) => name).join(', ')}
                    </>
                  )}
                </span>
              )}
            </div>
            <div className="flex-grow" />
            <div className="h-3 w-3 bg-red-600 rounded-full self-center" />
          </button>
        ))}
        {(total === 0 || remaining > 0) && (
          <EmptystateButton
            onClick={event => {
              event.preventDefault();
              onClickChats(event);
            }}
          >
            {remaining > 0 ? (
              <>
                <span>{t('physician_welcome_screen.unread.unread')} </span>{' '}
                <span className="text-blue-500 ml-1 group-hover:underline">
                  {t('physician_welcome_screen.unread.link')}
                </span>
              </>
            ) : (
              <>
                <span>{t('physician_welcome_screen.unread.no_unread.info')}</span>{' '}
                <span className="text-blue-500 ml-1 group-hover:underline">
                  {t('physician_welcome_screen.unread.no_unread.button_text')}
                </span>
              </>
            )}
          </EmptystateButton>
        )}
      </div>
    </div>
  );
};

NewMessages.defaultProps = {
  chats: [],
  total: 0,
  remaining: 0,
  onClickChat: () => {},
  onClickChats: () => {},
};

NewMessages.propTypes = {
  chats: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      count: PropTypes.number,
      text: PropTypes.string,
      files: PropTypes.string,
      title: PropTypes.string,
      avatar: PropTypes.string,
      initials: PropTypes.string,
      isDeleted: PropTypes.bool,
    }),
  ),
  total: PropTypes.number,
  remaining: PropTypes.number,
  onClickChat: PropTypes.func,
  onClickChats: PropTypes.func,
};

export default NewMessages;
